import { observable, action } from "mobx"
import { authStore } from "../../stores"
import { firebase, PRODUCTS_ENDPOINT } from "../../constants"
import { createProduct, validConfig } from "./utils"

class ProductStore {
  @observable error = null
  @observable loading = false
  @observable products = observable.map()
  @observable baseProducts = observable.map()

  @action.bound
  handleProducts(baseProducts) {
    if (baseProducts) {
      Object.keys(baseProducts).forEach(
        action(productId => {
          this.baseProducts.set(productId, baseProducts[productId])
        })
      )
    }
    firebase
      .database()
      .ref(`stores/${authStore.userStoreId}/products`)
      .on("value", snap => {
        const products = snap.val()
        if (products) {
          Object.keys(products).forEach(
            action(id => {
              const config = products[id]
              const base = this.baseProducts.get(config.product_id)
              if (base && validConfig(config)) {
                const product = createProduct(id, config, base)
                this.products.set(id, product)
              } else {
                console.warn("Invalid product config", config)
              }
            })
          )
        }
      })
  }

  @action.bound
  loadProducts() {
    this.loading = true
    window
      .fetch(PRODUCTS_ENDPOINT, { method: "GET" })
      .then(res => res.json())
      .then(this.handleProducts)
      .catch(action(err => (this.error = err)))
      .then(action(() => (this.loading = false)))
  }

  @action.bound
  deleteProduct(id) {
    firebase
      .database()
      .ref(`stores/${authStore.userStoreId}/products/${id}`)
      .remove()
    this.products.delete(id)
  }
}

export default new ProductStore()



// WEBPACK FOOTER //
// ./src/products/list/store.js